export default __webpack_public_path__ + "nonomobaby-logo.4e5baf3.svg";